export default __webpack_public_path__ + "static/media/banco-serfinanza.2c86235a.svg";